import React, {useEffect} from 'react'
import {useTranslation} from "react-i18next";
import {Box, Typography} from "@mui/material";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";


const InfoPagePeriodLayout = () =>{
    const {t} = useTranslation()
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/info/period",
            type:"pageView"
        }))
    }, []);
    return (
        <Box component="main">
            <Typography style={{textAlign:"center", alignItems:"center"}}  variant="h3" gutterBottom>
                {t('info_page.period.title' as any)}
            </Typography>
            <Typography paragraph>
                {t('info_page.period.subtitle' as any)}:
                <ol>
                    <li>{t('info_page.period.item_1_title' as any)}</li>
                    <li>{t('info_page.period.item_2_title' as any)}</li>
                    <li>{t('info_page.period.item_3_title' as any)}</li>
                    <li>{t('info_page.period.item_4_title' as any)}</li>
                </ol>
            </Typography>
            <Typography variant="h6">
                {t('info_page.period.item_1_title' as any)}
            </Typography>
            <Typography paragraph>
                {t('info_page.period.item_1_description' as any)}
            </Typography>
            <Typography variant="h6">
                {t('info_page.period.item_2_title' as any)}
            </Typography>
            <Typography paragraph>
                {t('info_page.period.item_2_description' as any)}
            </Typography>
            <Typography variant="h6">
                {t('info_page.period.heading' as any)}
            </Typography>
            <Typography paragraph>
                {t('info_page.period.item_3_description' as any)}
             </Typography>
            <Typography paragraph>
                {t('info_page.period.scenarios_title' as any)} :
            </Typography>
            <Typography paragraph>
                <ul>
                    <li> {t('info_page.period.scenario_item_1' as any)}
                    </li>
                    <li> {t('info_page.period.scenario_item_2' as any)}
                    </li>
                    <li> {t('info_page.period.scenario_item_3' as any)}
                    </li>
                    <li> {t('info_page.period.scenario_item_4' as any)}</li>
                </ul>
            </Typography>
            <Typography paragraph>
                {t('info_page.period.scenario_description' as any)}
            </Typography>

        </Box>
    )
}
export default InfoPagePeriodLayout
